/**
 * Entorno pre. Genera www
 *
 * Compilar:
 *
 * - ng run app:build:pre [--options]
 * - ionic build --configuration=pre [--options]
 *
 */

import { common } from './environment.common';
import { custom } from './environment.custom';

const env = {
  // habilita el service worker
  production: true,

  // conexión api
  apiUrl: 'https://apidemo.alares.org/api',

  // url de la app
  appUrl: custom.appUrlDomain + '.org',

  // analytics
  analyticsStatus: false,

  // testamentis
  testamentisHereditario: 'https://dev.testamentis.com/testamento-online/hereditario',
  testamentisModificacion: 'https://dev.testamentis.com/testamento-online/modificacion',
  testamentisVital: 'https://dev.testamentis.com/testamento-online/vital'
};

// env es el último en cargar y sobreescribe cambios anteriores
export const environment = {...common, ...custom, ...env};
